module.exports = __webpack_public_path__ + "static/media/Immunotherapy.eb6e64be.svg";